

// ------- BRAND / PRIMARY -------
export const brandColor = "#CE20B0";
export const brandColorEnd = "#0290AC";
export const brandGradient = "linear-gradient(105.79deg, #CE20B0 -55.96%, #0290AC 226.34%)";
export const blue = "#008ac0";
export const mainDarkBlue = "#CE20B0";
export const mainLightBlue = "#008ac0";

// ------- PALETTE: BLUES -------
export const primaryBlue = "#8EACCD";
export const primaryLightBlue = "#43bbff";
export const primaryLightBluePicton = "#669bd9";
export const primaryLightSkyBlue = "#d9f1ff";
export const frenchPass = "#b6dff9";
export const accentLightBlue = "#b4e4ff";
export const materialBlue = "#2196F3";
export const bootstrapPrimary = "#0d6efd";
export const focusGlowBlue = "#33bbf1";
export const antBlue = "#1890ff";
export const antBlueHover = "#40a9ff";
export const infoTeal = "#17a2b8";
export const deepNavy = "#1e3a8a";
export const deepNavyLight = "#1e40af";
export const dollarIconBlue = "#0058BF";
export const darkTeal = "#006699";
export const hoverBrandBlue = "#007bb5";
export const paginationActive = brandColor;
export const sidebarActive = "#25b0e7";
export const mediumBlueBg = "#53b3eb";

// ------- PALETTE: GREENS -------
export const primaryGreen = "#B6C7AA";
export const primaryGreenAlfa = "#A1D6B2";
export const primaryLightGreen = "#a7dcd3";
export const primaryLightGreenAlfa = "#d5e8e8";
export const primaryDarkGreenAlfa = "#2d8a8a";
export const primaryFadeGreen = "#9ff5e9";
export const springRain = "#a0f6e9";
export const successBg = "#5aa469";
export const successText = "#16a34a";
export const successLightBg = "#dcfce7";
export const greenFlag = "#2D8A39CC";
export const activeBorderGreen = "#05ae0e";
export const lightGreenBg = "#abd0b0";
export const scheduleBadgeGreen = "#81c08b";
export const notificationSuccess = "rgb(95, 255, 119)";
export const notificationSuccessAlfa = "rgba(95, 255, 119, 0.2)";

// ------- PALETTE: REDS -------
export const primaryRed = "#d02929";
export const primaryDarkRed = "#f77563";
export const primaryDarkRedAlfa = "#f3726166";
export const primaryLightRed = "#eba9a9";
export const lightRed = "#DF6A6A";
export const red = "#FD7E89";
export const dangerRed = "#dc3545";
export const dangerHover = "#c82333";
export const errorText = "#dc2626";
export const errorLightBg = "#fee2e2";
export const userLockRed = "#FD5E49";

// ------- PALETTE: ORANGES / YELLOWS -------
export const primaryOrange = "#fecd8d";
export const primaryOrangeYellow = "#f6c688";
export const primaryLightYellow = "#ffdfb4";
export const timerIconOrange = "#FFAE43";
export const warningBg = "#eec759";
export const warningText = "#f59e0b";
export const warningLightBg = "#fef3c7";

// ------- PALETTE: PURPLES / PINKS -------
export const primaryPurple = "#aca8f9";
export const primaryLightPurple = "#bebbfb";
export const primaryPink = "#f897d4";
export const primaryLightPink = "#eba9d3";
export const gradientPurpleStart = "#6f42c1";
export const gradientPurpleEnd = "#9b59b6";

// ------- NEUTRALS: WHITE / LIGHT -------
export const white = "#ffffff";
export const offWhite = "#fcfcfc";
export const nearWhite = "#fafafa";
export const lightBg1 = "#f9f9f9";
export const lightBg2 = "#f8f9fa";
export const lightBg3 = "#f5f5f5";
export const formLightBg = "#f1f2f5";
export const formDarkBg = "#dbdfe4";

// ------- NEUTRALS: GRAY -------
export const gainsboro = "#e9ecef";
export const borderLight = "#dee2e6";
export const borderInput = "#ced4da";
export const borderMedium = "#cccccc";
export const borderMuted = "#b5b5b5";
export const borderFaint = "#ececec";
export const lightGray = "#b5bac6";
export const lightGray2 = "#334163";
export const gray = "#3f4d70";
export const mutedGray = "#8A92A6";
export const mutedGrayAlfa = "#8a92a640";
export const mediumGray = "#6c757d";
export const darkGrayText = "#495057";
export const paginationText = "#2a2a2a";
export const textDarkAlt = "#333333";
export const textDarkNearBlack = "#343434";
export const stormGray = "#717378";
export const grey = "#d1d0d0";
export const textGrey = "#b4b9c7";

// ------- NEUTRALS: BLACK / DARK -------
export const black = "#000000";
export const dark = "#12151e";

// ------- DARK MODE -------
export const darkMode = "#12151e";
export const darkModeLight = "#1c1f29";
export const darkShade = "#0e1217";
export const tableHeadColor = "#23262e";
export const dmRowHover = "#2a2d37";
export const dmBorder = "#32333a";
export const dmInputBorder = "#464750";
export const dmTextLight = "#e0e0e0";
export const dmTextMuted = "#b4b9c7";
export const dmPanelBg = "#1e1e2d";
export const dmOptionHover = "#2d2d3d";

// ------- SHADOWS / OVERLAYS -------
export const shadowBrandGray = "rgba(138, 146, 166, 0.2)";
export const overlayDark = "rgba(0, 0, 0, 0.75)";
export const overlayLight = "rgba(255, 255, 255, 0.9)";

// ------- STATUS (for toasts / badges) -------
export const toastSuccessText = "#16a34a";
export const toastSuccessBg = "#dcfce7";
export const toastErrorText = "#dc2626";
export const toastErrorBg = "#fee2e2";
export const toastWarningText = "#f59e0b";
export const toastWarningBg = "#fef3c7";
export const toastInfoText = "#0284c7";
export const toastInfoBg = "#e0f2fe";
export const toastHeadingText = "#111827";
export const toastBodyText = "#4b5563";

// ------- DOWNLOAD LOG -------
export const downloadCardBg = "rgb(240, 248, 253)";
export const downloadCloseBg = "#d3e9f0";
export const downloadProgress = "rgba(75, 176, 216, 1)";
export const downloadText = "rgba(17, 24, 39, 1)";

// ------- SEND ICON / MISC -------
export const sendIcon = "#4995b7";

// ------- AVATAR COLORS -------
export const avatarColors = [
  "#3f93c3",
  "#e957b4",
  "#a7a2fc",
  "#e6a244",
  "#f68375",
  "#21bdbd",
  "#55c0fc",
  "#7bd187",
  "#fcd5d6",
];
